import { useTypedParams } from '@sorare/routing';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';

import { InventoryLayout } from '@sorare/gameplay/src/layouts/inventory/InventoryLayout';

import { LayoutParams } from 'pages/__generated__/routeParams';

const FootballInventory = () => {
  const { type } = useTypedParams<LayoutParams>();
  return <InventoryLayout sport={Sport.FOOTBALL} type={type as Rarity} />;
};

export default FootballInventory;
